import { load } from 'recaptcha-v3';
import * as dateFns from 'date-fns';
import getT from 'next-translate/getT';
import axios from 'axios';

// Ensure i18n config is available globally during build/serverless

import {
  DIVERSITY_INDICATOR_TEXT_DE,
  DIVERSITY_INDICATOR_TEXT_EN,
  DIVERSITY_INDICATOR_TEXT_ES,
  DIVERSITY_INDICATOR_TEXT_FR,
} from '../constants';
import logger from './logger';

if (typeof global !== 'undefined' && !global.i18nConfig) {
  try {
    // eslint-disable-next-line import/no-dynamic-require, global-require
    global.i18nConfig = require('../../i18n');
  } catch (error) {
    // Silently fail if config can't be loaded
  }
}

// const TALENT_ID = {
//   en: 'field:6732980',
//   es: 'field:6732980',
//   de: 'field:6951495',
//   fr: 'field:6951418',
// };

// const JOB_ID = {
//   en: 'field:6732981',
//   es: 'field:6732981',
//   de: 'field:6951496',
//   fr: 'field:6951421',
// };

// const JOB_CODE = {
//   en: 'field:7970559',
//   es: 'field:7970559',
//   de: 'field:7970528',
//   fr: 'field:7970622',
// };

// const SCHEDULE_URL = {
//   en: 'https://lionstep.as.me',
//   de: 'https://lionstep-deutsch.as.me',
//   fr: 'https://lionstep-french.as.me',
// };

// const APPOINTMENT_TYPE = {
//   'Digital & Technology': {
//     en: 21094376,
//     de: 21098476,
//     fr: 21098749,
//   },
//   'Financial Services and Insurances': {
//     en: 21094382,
//     de: 21098486,
//     fr: 21098753,
//   },
//   'Consumer & Retail / Sales': {
//     en: 21094440,
//     de: 21098489,
//     fr: 21098773,
//   },
//   'Marketing & Media': {
//     en: 21094457,
//     de: 21098493,
//     fr: 21098799,
//   },
//   'Pharma & Life Sciences': {
//     en: 21094462,
//     de: 21098504,
//     fr: 21098812,
//   },
//   'Real Estate': {
//     en: 21094468,
//     de: 21098512,
//     fr: 21098818,
//   },
//   'Professional Services & Business Services': {
//     en: 21094470,
//     de: 21098520,
//     fr: 21098823,
//   },
//   'Industrial & Automotive': {
//     en: 21094475,
//     de: 21098526,
//     fr: 21098831,
//   },
//   Telecom: {
//     en: 21094484,
//     de: 21098539,
//     fr: 21098838,
//   },
// };

async function getRecaptcha(publicConfig) {
  try {
    if (publicConfig.ENV === 'dev') {
      return publicConfig.RECAPTCHA_DEV_TOKEN;
    }
    const recaptcha = await load(publicConfig.RECAPTCHA_SITE_KEY);
    return recaptcha.execute();
  } catch (error) {
    logger(error, { extra: { info: 'Fail creating recaptcha' } });

    throw new Error(error);
  }
}

async function postData(url, data, publicConfig) {
  const response = await axios.post(`${publicConfig.PYTHON_API}/${url}`, data);
  return response.data;
}

async function putData(url, data, publicConfig) {
  const response = await axios.put(`${publicConfig.PYTHON_API}/${url}`, data);
  return response.data;
}

async function getData(url, data, publicConfig) {
  const response = await axios.get(`${publicConfig.PYTHON_API}/${url}`, data);
  return response.data;
}

function detectBrowser() {
  navigator.sayswho = (function () {
    const ua = navigator.userAgent;
    let tem;
    let M =
      ua.match(
        /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i,
      ) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return `IE ${tem[1] || ''}`;
    }
    if (M[1] === 'Chrome') {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem != null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
    tem = ua.match(/version\/(\d+)/i);
    if (tem != null) M.splice(1, 1, tem[1]);
    return M.join(' ');
  })();

  return navigator.sayswho;
}

function getOS() {
  const { userAgent } = window.navigator;
  const { platform } = window.navigator;
  const macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'];
  const windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];
  const iosPlatforms = ['iPhone', 'iPad', 'iPod'];
  let os = null;

  if (macosPlatforms.indexOf(platform) !== -1) {
    os = 'Mac OS';
  } else if (iosPlatforms.indexOf(platform) !== -1) {
    os = 'iOS';
  } else if (windowsPlatforms.indexOf(platform) !== -1) {
    os = 'Windows';
  } else if (/Android/.test(userAgent)) {
    os = 'Android';
  } else if (!os && /Linux/.test(platform)) {
    os = 'Linux';
  }

  return os;
}

const langShorthand = (lang) => {
  if (lang === 'english') {
    return 'en';
  }
  if (lang === 'german' || lang === 'deutsch') {
    return 'de';
  }
  if (lang === 'spanish' || lang === 'español') {
    return 'es';
  }
  if (lang === 'french' || lang === 'français') {
    return 'fr';
  }
  return 'en';
};

// function switchJobIndustry(jobIndustry, jobLang, jobQueryParams) {
//   const appointmentTypeByLanguage = APPOINTMENT_TYPE[jobIndustry];

//   if (appointmentTypeByLanguage) {
//     const scheduleUrl = SCHEDULE_URL[jobLang] || SCHEDULE_URL.en;
//     const appointmentType =
//       appointmentTypeByLanguage[jobLang] || appointmentTypeByLanguage.en;
//     return `${scheduleUrl}?appointmentType=${appointmentType}&${jobQueryParams}`;
//   }
//   return '';
// }

// const calculateCalendlyLink = (
//   job,
//   talentId,
//   talent,
//   company,
//   publicConfig,
// ) => {
//   if (!job) {
//     return '';
//   }

//   const jobId = job.id ?? '';
//   const jobCode = job.public_url ?? '';
//   const jobLang = langShorthand(job.job_language?.mid ?? 'english');
//   let redirectUrl = '';

// eslint-disable-next-line max-len
//   const jobQueryParams = `${TALENT_ID[jobLang]}=${talentId}&${JOB_ID[jobLang]}=${jobId}&${JOB_CODE[jobLang]}=${jobCode}`;

//   if (publicConfig.ENV !== 'production') {
//     // QA & Dev
//     if (jobLang === 'de') {
//       redirectUrl = `${SCHEDULE_URL.de}?appointmentType=23815139&${jobQueryParams}`;
//     } else if (jobLang === 'fr') {
//       redirectUrl = `${SCHEDULE_URL.fr}?appointmentType=26362000&${jobQueryParams}`;
//     } else {
//       redirectUrl = `${SCHEDULE_URL.en}/?appointmentType=23814403&${jobQueryParams}`;
//     }
//   } else if (company.acuity_links?.[jobLang]) {
//     redirectUrl = `${company.acuity_links?.[jobLang]}&${jobQueryParams}`;
//   } else if (job.job_industry) {
//     redirectUrl = switchJobIndustry(job.job_industry, jobLang, jobQueryParams);
//   }

//   if (!redirectUrl) {
//     // default english url
//     redirectUrl = `${SCHEDULE_URL.en}/job-opportunity-call-with-lionstep-recruiter?${jobQueryParams}`;

//     // special case for a german where job we have a different flow
//     if (job.extra_info?.acuity_meeting_url) {
//       redirectUrl = `${job.extra_info?.acuity_meeting_url}?${jobQueryParams}`;
//     } else {
//       if (jobLang === 'de') {
//         redirectUrl = `${SCHEDULE_URL.de}?appointmentType=12295201&${jobQueryParams}`;
//       }
//       if (jobLang === 'fr') {
//         redirectUrl = `${SCHEDULE_URL.fr}/schedule.php?appointmentType=11924213&${jobQueryParams}`;
//       }
//     }
//   }

//   if (talent?.firstName && talent?.lastName && talent?.email) {
//     redirectUrl += `&firstName=${encodeURIComponent(
//       talent.firstName,
//     )}&lastName=${encodeURIComponent(
//       talent.lastName,
//     )}&email=${encodeURIComponent(talent.email)}`;
//   }
//   return redirectUrl;
// };

const copyTextToClipboard = (text) => {
  const copyText = document.createElement('textarea');
  copyText.value = text;
  copyText.setAttribute('readonly', '');
  copyText.style.position = 'absolute';
  copyText.style.left = '-9999px';
  document.body.appendChild(copyText);
  copyText.select();
  document.execCommand('copy');
  document.body.removeChild(copyText);
};

const calculateJobDescription = async (lang, job, company) => {
  const approach = job.approach ?? 'formal';
  const t = await getT(lang, 'common');

  const requiredLangs = job.talent_languages?.filter(
    (language) => language.importance === 'required',
  );
  const desiredLangs = job.talent_languages?.filter(
    (language) => language.importance === 'desired',
  );

  const hasNiceToHave =
    // job.extra_info?.leadership_experience ||
    // job.extra_info?.leadership_importance === 'desired'
    // (job.extra_info?.travel &&
    //   job.extra_info?.travel_importance === 'desired') ||
    desiredLangs.length > 0;

  const hasTeamSection =
    job.extra_info?.team_desc ||
    job.extra_info?.superior_role ||
    job.extra_info?.team_size ||
    job.extra_info?.team_language;
  const hasBenefits =
    job.benefits_pool_selected?.length > 0 ||
    job.benefits_custom_selected?.length > 0;
  // job.extra_info?.additional_benefits;

  // summary_section
  let description = `<p><strong>${t(
    `description_page.summary_section.title.${approach}`,
  )}</strong><br>${job.extra_info?.summary}<br>`;

  // what_you_will_do_section
  description += `<strong>${t(
    `description_page.what_you_will_do_section.title.${approach}`,
  )}</strong><br>${job.extra_info?.your_role}`;
  // if (job.extra_info?.management_role) {
  //   description += `<br><ul><li>${t(
  //     `description_page.what_you_will_do_section.manages.${approach}`,
  //   )}: ${t(
  //     `description_page.what_you_will_do_section.direct_reports.${approach}`,
  //     {
  //       people_to_manage: job.extra_info?.peopleToManage,
  //     },
  //   )}</li></ul>`;
  // }
  description += '<br>';

  // what_you_bring_section
  description += `<strong>${t(
    `description_page.what_you_bring_section.title.${approach}`,
  )}</strong><br>${job.extra_info?.requirements}<br><ul>`;

  // if (
  //   job.extra_info?.travel &&
  //   job.extra_info?.travel_importance === 'required'
  // ) {
  //   description += `<li>${t(
  //     `description_page.what_you_bring_section.travel_requirement.${approach}`,
  //   )}${
  //     job.extra_info?.travel_details ||
  //     t(`questions_page.yes_no_values.yes.${approach}`)
  //   }</li>`;
  // }

  // if (
  //   job.extra_info?.leadership_experience
  //   job.extra_info?.leadership_importance === 'required'
  // ) {
  //   description += `<li>${t(
  //     `description_page.what_you_bring_section.experience.${approach}`,
  //   )}: ${t(
  //     `description_page.what_you_bring_section.management_role.${approach}`,
  //   )}</li>`;
  // }
  if (requiredLangs.length > 0) {
    requiredLangs.forEach((language) => {
      const l = language.display?.[lang] ?? language.mid;
      description += `${`<li>${l.charAt(0).toUpperCase() + l.slice(1)}: `}${t(
        `description_page.language_proficiency.${language.level}.${approach}`,
      )}</li>`;
    });
  }
  description += '</ul>';
  description += '<br>';

  // nice_to_haves_section
  description += `<strong>${t(
    `description_page.nice_to_haves_section.title.${approach}`,
  )}</strong><br>${job.extra_info?.nice_to_have}`;
  if (hasNiceToHave) {
    description += '<ul>';
    // if (
    //   job.extra_info?.travel &&
    //   job.extra_info?.travel_importance === 'desired'
    // ) {
    //   description +=
    //     `<li>${t(
    //       `description_page.what_you_bring_section.travel_requirement.${approach}`,
    //     )}: ` +
    //     `${
    //       job.extra_info?.travel_details ||
    //       t(`questions_page.yes_no_values.yes.${approach}`)
    //     }` +
    //     '</li>';
    // }
    // if (
    //   job.extra_info?.leadership_experience &&
    //   job.extra_info?.leadership_importance === 'desired'
    // ) {
    //   description += `<li>${t(
    //     `description_page.what_you_bring_section.experience.${approach}`,
    //   )}: ${t(
    //     `description_page.what_you_bring_section.management_role.${approach}`,
    //   )}</li>`;
    // }
    if (desiredLangs.length > 0) {
      desiredLangs.forEach((language) => {
        const l = language.display?.[lang] ?? language.mid;
        description += `${`<li>${l.charAt(0).toUpperCase() + l.slice(1)}: `}${t(
          `description_page.language_proficiency.${language.level}.${approach}`,
        )}</li>`;
      });
    }
    description += '</ul>';
  }
  description += '<br>';

  // your_team_section
  if (hasTeamSection) {
    description += `<strong>${t(
      `description_page.your_team_section.title.${approach}`,
    )}</strong><br><ul>`;
    if (job.extra_info?.superior_role) {
      description += `<li>${t(
        `description_page.your_team_section.reports_to.${approach}`,
      )}: ${job.extra_info?.superior_role}</li>`;
    }
    if (job.extra_info?.team_size) {
      description += `<li>${t(
        `description_page.your_team_section.colleagues.${approach}`,
      )}: ${job.extra_info?.team_size}</li>`;
    }
    if (job.extra_info?.team_language) {
      description +=
        `<li>${t(
          `description_page.your_team_section.team_language.${approach}`,
        )}: ` +
        `${
          job.extra_info?.team_language.charAt(0).toUpperCase() +
          job.extra_info?.team_language.slice(1)
        }` +
        '</li>';
    }
    description += '</ul>';
    description += '<br>';
  }

  // benefits_section
  if (hasBenefits) {
    description += `<strong>${t(
      `description_page.benefits_section.title.${approach}`,
    )}</strong><br>`;

    if (
      job.benefits_pool_selected?.length > 0 ||
      job.benefits_custom_selected?.length > 0
    ) {
      description += '<ul>';
      if (job.benefits_pool_selected?.length > 0) {
        job.benefits_pool_selected.forEach((benefit_id) => {
          description += `<li>${t(
            `description_page.benefits_section.default_benefits.${benefit_id}.${approach}`,
          )}</li>`;
        });
      }
      if (job.benefits_custom_selected?.length > 0) {
        job.benefits_custom_selected.forEach((benefit_id) => {
          if (
            company.benefits_custom
              ?.find((benefit) => benefit.id === benefit_id)
              ?.description?.find((desc) => desc.lang === lang)?.content
          ) {
            description += `<li>${
              company.benefits_custom
                ?.find((benefit) => benefit.id === benefit_id)
                ?.description?.find((desc) => desc.lang === lang)?.content
            }</li>`;
          }
        });
      }
      description += '</ul>';
    }
    // if (job.extra_info?.additional_benefits) {
    //   description += job.extra_info?.additional_benefits;
    // }
    description += '<br>';
  }

  description += '</p>';

  return description;
};

const calcDiversityText = (jobLang) => {
  switch (langShorthand(jobLang)) {
    case 'en':
      return DIVERSITY_INDICATOR_TEXT_EN;
    case 'de':
      return DIVERSITY_INDICATOR_TEXT_DE;
    case 'fr':
      return DIVERSITY_INDICATOR_TEXT_FR;
    case 'es':
      return DIVERSITY_INDICATOR_TEXT_ES;
    default:
      return DIVERSITY_INDICATOR_TEXT_EN;
  }
};

const buildGoogleJobsSchema = async (
  lang,
  job,
  company,
  googleLocationArray,
) => {
  const dateCreated = new Date(job.created);
  const validThrough = new Date(dateCreated.getTime());
  validThrough.setMonth(validThrough.getMonth() + 6);

  const description = await calculateJobDescription(lang, job, company);

  let employmentType = 'PART_TIME';

  // if (job.extra_info?.contract_type === 'Limited') {
  //   employmentType = 'TEMPORARY';
  // } else
  if (job.extra_info?.employment_type === 'fulltime') {
    employmentType = 'FULL_TIME';
  }

  const country =
    googleLocationArray.find((obj) => obj.types.includes('country'))
      ?.short_name ?? '';

  const streetName = googleLocationArray.find((obj) =>
    obj.types.includes('route'),
  )?.short_name;
  const streetNumber = googleLocationArray.find((obj) =>
    obj.types.includes('street_number'),
  )?.short_name;

  let street = '';
  if (streetName) street = streetName;
  if (streetName && streetNumber) street += ` ${streetNumber}`;

  const city =
    googleLocationArray.find((obj) => obj.types.includes('locality'))
      ?.long_name ?? '';
  const postalCode =
    googleLocationArray.find((obj) => obj.types.includes('postal_code'))
      ?.short_name ?? '';

  const jobLocation = {
    '@type': 'Place',
    address: {
      '@type': 'PostalAddress',
      addressCountry: country,
    },
  };
  if (street) jobLocation.address.streetAddress = street;
  if (city) jobLocation.address.addressLocality = city;
  if (postalCode) jobLocation.address.postalCode = postalCode;

  const schema = {
    '@context': 'https://schema.org/',
    '@type': 'JobPosting',
    title: `${job.opening_title}${
      job.extra_info?.diversity
        ? ` ${calcDiversityText(job.job_language?.mid)}`
        : ''
    }`,
    description,
    datePosted: dateFns.format(dateCreated, 'yyyy-MM-dd'),
    validThrough: dateFns.format(validThrough, 'yyyy-MM-dd'),
    hiringOrganization: {
      '@type': 'Organization',
      name: company.company_name,
      sameAs: company.company_url ?? '',
      logo: company.logo_url ?? '',
    },
    identifier: {
      '@type': 'PropertyValue',
      name: 'Lionstep',
      value: job.id,
    },
    employmentType,
    jobLocation,
    applicantLocationRequirements: {
      '@type': 'Country',
      name: country,
    },
  };

  if (
    // job.fully_remote ||
    job.extra_info?.homeoffice &&
    job.extra_info?.home_days === 5
  ) {
    schema.jobLocationType = 'TELECOMMUTE';
  }

  return schema;
};

const getElementTextContent = (htmlString) => {
  const el = document.createElement('div');
  el.innerHTML = htmlString;
  return el.textContent;
};

function isVisible(domElement) {
  return new Promise((resolve) => {
    const o = new IntersectionObserver(([entry]) => {
      resolve(entry.intersectionRatio === 1);
      o.disconnect();
    });
    o.observe(domElement);
  });
}

export {
  getRecaptcha,
  postData,
  putData,
  getData,
  detectBrowser,
  getOS,
  // calculateCalendlyLink,
  langShorthand,
  copyTextToClipboard,
  buildGoogleJobsSchema,
  getElementTextContent,
  isVisible,
  calcDiversityText,
};
